import { render, staticRenderFns } from "./collection-preview.vue?vue&type=template&id=10bf79db&scoped=true&"
import script from "./collection-preview.vue?vue&type=script&lang=js&"
export * from "./collection-preview.vue?vue&type=script&lang=js&"
import style0 from "./collection-preview.vue?vue&type=style&index=0&id=10bf79db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bf79db",
  null
  
)

export default component.exports